<template>
  <div :class="showanswer">
    <div class="showimg-info"
         :style="'background-image:url('+baseurl+showanswerinfo[1]+');background-size:100% 100%;'"></div>
    <div class="showanswer-text-info">{{showanswerinfo[0]}}</div>
    <div class="showanswer-play-btn" @click="playaudioshow(showanswerinfo)"></div>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"

  export default {
    name: "eliminatecard",
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
      }
    },
    props: {
      showanswerinfo: {
        type: Array,
        default: function () {
          return []
        }
      },
      showanswer: {
        type: String,
        default: "showanswer"
      }
    },
    methods: {
      playaudioshow(info) {
        this.$emit("playaudioshow", info)
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .showanswer {
    width 25%;
    height 55%;
    background #fff;
    border-radius 36px;
    border 6px solid #5D79FA;
    position absolute;
    left 35%;
    top 10%;
    z-index 10;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
    margin 10px;

    .showimg-info {
      width 50%;
      height 0;
      padding-top 50%;
      margin-bottom 10px;
    }

    .showanswer-text-info {
      font-size 48px;
    }

    .showanswer-play-btn {
      width 30%;
      padding-top 30%;
      margin-top 10px;
      background url("../../assets/img/showanswer-play-btn.png")
      background-size 100% 100%;
    }
  }

  .showanswer1 {
    width 18%;
    height 60%;
    background #fff;
    border-radius 36px;
    border 6px solid #5D79FA;
    z-index 10;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
    margin 10px;

    .showimg-info {
      width 40%;
      height 0;
      padding-top 40%;
      margin-bottom 10px;
    }

    .showanswer-text-info {
      font-size 40px;
    }

    .showanswer-play-btn {
      width 100px;
      padding-top 100px;
      margin-top 10px;
      background url("../../assets/img/showanswer-play-btn.png")
      background-size 100% 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/eliminatecard.vue